import { render, staticRenderFns } from "./xtdzDetail.vue?vue&type=template&id=50fb6d54&scoped=true&"
import script from "./xtdzDetail.vue?vue&type=script&lang=js&"
export * from "./xtdzDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fb6d54",
  null
  
)

export default component.exports